export default {
  route: {
    dashboard: '首页',
    introduction: '简述',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    bar: 'Bar',
    barProfile: 'Profile',
    barPosts: 'Posts',
    Table: 'Table',
    dynamicTable: '动态Table',
    dragTable: '拖拽Table',
    inlineEditTable: 'Table内编辑',
    complexTable: '综合Table',
    treeTable: '树形表格',
    customTreeTable: '自定义树表',
    tab: 'Tab',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    organManage: '组织架构管理',
    organList: '组织架构列表',
    organAdd: '添加组织',
    organEdit: '修改组织',
    majorManage: '专业管理',
    courseManage: '课程管理',
    orderManage: '缴费管理',
    userManage: '用户管理',
    courseSelect: '选课中心',
    majorDetails: '专业详情',
    my: '个人中心',
    myOrder: '我的缴费',
    myCourse: '我的课程',
    myCourseExam: '我的课程练习',
    majorList: '专业列表',
    majorCourseList: '专业课程管理',
    majorAddCourse: '专业添加课程',
    majorEdit: '编辑专业',
    majorAdd: '添加专业',
    schoolManage: '学校管理',
    schoolList: '学校列表',
    schoolEdit: '学校编辑',
    courseList: '课程列表',
    courseInfo: '课程详情',
    courseDiscussion: '课程讨论',
    class: '班级管理',
    classList: '班级列表',
    classEdit: '修改班级',
    classAdd: '添加班级',
    classDetails: '班级详情',
    studentList: '班级学生列表',
    studentEdit: '修改学生信息',
    studentAdd: '添加学生',
    orderList: '缴费管理',
    orderDetail: '缴费详情',
    shopCart: '购物车',
    shopCartList: '购物车列表',
    userList: '用户列表',
    myOrderList: '我的缴费列表',
    myCourseList: '我的课程列表',
    myCourseDetail: '我的课程详情',
    myCourseCourseware: '我的课程课件',
    myCourseDiscussionDetail: '帖子详情',
    myInfo: '个人信息',
    myInfoDetail: '个人信息',
    resetPassword: '修改密码',
    myOrderDetail: '我的缴费详情',
    fileManage: '文件管理',
    fileUpload: '文件上传',
    fileList: '文件列表',
    examManage: '考试管理',
    examList: '考试列表',
    examDetail: '考试详情',
    examAdd: '添加考试',
    examEdit: '编辑考试',
    examScoringList: '考试试卷列表',
    examScoringDetail: '考试试卷详情',
    paperManage: '试卷管理',
    paperList: '试卷列表',
    paperDetail: '试卷详情',
    paperAdd: '添加试卷',
    paperEdit: '编辑试卷',
    questionManage: '题目管理',
    questionList: '题目列表',
    questionDetail: '题目详情',
    questionEdit: '编辑题目',
    questionAdd: '添加题目',
    scoreSearch: '成绩查询',
    scoreList: '成绩列表',
    courseOutline: '课程大纲',
    courseUnitContent: '课程章节内容',
    courseManageInfo: '课程公告',
    courseTab: '课程内容',
    courseTextbook: '课程教材',
    courseSetting: '课程设置',
    courseGrading: '课程评分',
    discussionDetail: '帖子详情',
    courseDetail: '课程详情',
    courseStudyProgress: '学习过程管理',
    courseCourseware: '课程课件',
    myOrderPayRedirect: '链接跳转',
    enroll: '快速报名',
    enrollForm: '报名表单',
    educated: '学籍管理',
    educatedList: '学籍列表',
    educatedEdit: '修改信息',
    detailsEducated: '学籍详情',
    educatedAdd: '添加学籍',
    renewal: '缴费管理',
    renewalList: '缴费列表',
    regularScoreQuery: '平时成绩查询',
    examScoreQuery: '在线考试成绩查询',
    myRegularScore: '我的平时成绩',
    userRegularScoreList: '用户平时成绩列表',
    myRegularScoreList: '平时成绩列表',
    myExamScore: '我的考试成绩',
    myExamScoreList: '成绩列表',
    myExamScoreDetail: '成绩详情',
    entrustmentScoreQuery: '委考/实践考成绩查询',
    myExamEnroll: '考试报名',
    myExamEnrollList: '委考/实践考报考',
    myExamEnrollAdd: '委考/实践考报考申请',
    preGraduated: '毕业预测',
    preGraduatedList: '毕业预测列表',
    examAudit: '考试审核',
    auditPaperList: '线上委考/实践考试卷审核',
    courseAdd: '添加课程',
    courseExamList: '练习列表',
    courseExamDetail: '练习详情',
    courseExamEdit: '练习编辑',
    courseExamAdd: '练习添加',
    examEnrollList: '报考申请列表',
    examEnrollDetail: '报考申请详情',
    myRegularScoreEnroll: '平时成绩申请',
    enrollOrderList: '报名缴费',
    renewalOrderList: '续费缴费',
    examOrderList: '报考缴费',
    totalList: '缴费统计',
    messageManage: '消息管理',
    messageList: '消息列表',
    messageEdit: '消息编辑',
    messageDetail: '消息详情',
    messageAdd: '消息添加',
    myMessage: '我的通知',
    goodsManage: '收费项目管理',
    goodsList: '收费项目列表',
    goodsStudyList: '学费管理',
    goodsExamList: '考试费管理',
    goodsDetail: '收费项目详情',
    goodsEdit: '收费项目编辑',
    goodsAdd: '收费项目添加',
    roleManage: '权限管理',
    roleList: '角色列表',
    roleAdd: '角色添加',
    roleEdit: '角色编辑',
    roleTeacherList: '教师列表',
    teacherManage: '教师管理',
    teacherList: '教师列表',
    teacherEdit: '教师编辑',
    teacherAdd: '教师添加',
    regularScoreStaticQuery: '平时成绩统计查询',
    homeworkManage: '作业管理',
    homeworkQuestionList: '作业题目列表',
    homeworkQuestionEdit: '作业题目编辑',
    homeworkQuestionAdd: '作业题目添加',
    homeworkPaperList: '作业试卷列表',
    homeworkPaperDetail: '作业试卷详情',
    homeworkPaperEdit: '作业试卷编辑',
    homeworkPaperAdd: '作业试卷添加',
    homeworkExamList: '作业列表',
    homeworkExamDetail: '作业详情',
    homeworkExamEdit: '作业编辑',
    homeworkExamAdd: '作业添加',
    myHomework: '我的作业',
    myHomeworkIndex: '我的作业列表',
    myHomeworkDetail: '我的作业题目',
    homeworkScoringList: '作业阅卷列表',
    homeworkScoringDetail: '作业阅卷详情',
    questionTagManage: '题目标签管理',
    questionTagList: '题目标签列表',
    appManage: 'APP管理',
    appUpdate: 'APP版本管理',
    appUpdateAdd: '添加APP新版本',
    appUpdateDetail: 'APP版本管理详情',
    appAdList: 'APP广告管理',
    appAdAdd: 'APP广告添加',
    appAdEdit: 'APP广告编辑',
    fileRecordList: '文件使用记录列表',
    practiceScoringList: '随堂练习阅卷学生列表',
    practiceScoringDetail: '随堂练习阅卷详情',
    practiceScoringChapterList: '随堂练习阅卷章节列表',
    testScoringList: '综合练习阅卷列表',
    testScoringDetail: '综合练习阅卷详情',
    statistics: '数据统计',
    statisticsStudentList: '学生数据统计',
    statisticsLogList: '请求日志统计',
    statisticsVideoPlayLogList: '视频播放时长统计',
    statisticsCourseList: '课程资源统计',
    statisticsCourseDetail: '课程资源统计详情',
    statisticsVideoPlayLogDetail: '视频播放时长统计详情',
    courseManageList: '课程管理列表',
    courseTestList: '综合练习课程列表',
    majorCategoryList: '专业分类列表',
    customerServiceManage: '客服咨询管理',
    knowingWay: '咨询信息获得方式',
    enrollInfo: '报名信息',
    paymentOrder: '小程序订单',
    consult: '咨询信息',
    consultStatistics: '咨询信息统计',
    payment: '定位费信息',
    consultAdd: '添加咨询信息',
    consultEdit: '编辑咨询信息',
    paymentAdd: '添加定位费信息',
    paymentEdit: '编辑定位费信息',
    follow: '跟进记录',
    userStatistics: '咨询师统计',
    userStatisticsList: '咨询师统计列表',
    userStatisticsDetail: '招生信息详情',
    advisoryManage: '咨询师管理',
    channelManage: '合作渠道管理',
    channelStatistics: '合作渠道统计'
  },
  navbar: {
    logOut: '退出',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤'
  },
  login: {
    title: '合作渠道系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    roles: '你的权限',
    switchRoles: '切换权限'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js